import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrderRoutingModule } from './order-routing.module';
import { MyOrdersComponent } from './Component/my-orders/my-orders.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { SharedModule } from '../shared/shared.module';
import { OrderDetailComponent } from './Component/order-detail/order-detail.component';
import { DateTimeFormatPipe } from '../core.pipes';
import {NgcCookieConsentModule} from 'ngx-cookieconsent';
import { OrderSelectionComponent } from './Component/order-selection/order-selection.component';
import { OrdersAvailableCartComponent } from './Component/orders-available-cart/orders-available-cart.component';
import { NgxNumberSpinnerModule } from '../ngx-number-spinner/ngx-number-spinner.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ApplicationIdComponent } from './Component/application-id/application-id.component';

@NgModule({
  declarations: [MyOrdersComponent, OrderDetailComponent, DateTimeFormatPipe, OrderSelectionComponent, OrdersAvailableCartComponent, ApplicationIdComponent],
  imports: [
    CommonModule,
    OrderRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    BsDropdownModule.forRoot(),
    AccordionModule.forRoot(),
    NgcCookieConsentModule,
    NgxNumberSpinnerModule ,
    InfiniteScrollModule
  ]
})
export class OrderModule { }
